import { render, staticRenderFns } from "./tags-renderer.vue?vue&type=template&id=39c417d8&"
import script from "./tags-renderer.vue?vue&type=script&lang=js&"
export * from "./tags-renderer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports